import { Type } from '@sinclair/typebox';
import { YesNo } from './contracts/ata/ata-schema.js';
import { NullishType } from './standard-schema.js';
export const GetForecastsParamsSchema = Type.Object({
    projectId: Type.String(),
});
export var ForecastType;
(function (ForecastType) {
    ForecastType["Forecast"] = "1_forecast";
    ForecastType["AtaOngoing"] = "2_ataongoing";
    ForecastType["AtaFixed"] = "3_atafixed";
})(ForecastType || (ForecastType = {}));
export const GetForecastsQuerySchema = Type.Object({
    type: NullishType(Type.Enum(ForecastType)),
});
export const ForecastDetailSchema = Type.Object({
    id: Type.String(),
    month: NullishType(Type.String()),
    budget: NullishType(Type.Number()), // Budget
    previousForecast: NullishType(Type.Number()), // FG.Prognos
    forecast: NullishType(Type.Number()), // Prognos
    result: NullishType(Type.Number()), // Utfall
    comment: NullishType(Type.String()),
    outsideOriginalForecast: Type.Boolean(),
});
export const SubForecastSchema = Type.Object({
    id: Type.String(),
    type: Type.String(),
    name: NullishType(Type.String()),
    accountNumber: NullishType(Type.Number()),
    ataNumber: NullishType(Type.Number()),
    budget: NullishType(Type.Number()),
    comment: NullishType(Type.String()),
    rows: Type.Array(ForecastDetailSchema),
});
export const ForecastSchema = Type.Object({
    id: Type.String(),
    type: Type.String(),
    name: NullishType(Type.String()), // Kontotyp
    accountTranslation: NullishType(Type.String()), // Översättningskonto
    comment: NullishType(Type.String()), // Kommentar
    isMissingInBudget: Type.Boolean(), // Visa varning att kontot saknas i budget
    ataFixedShouldBeForecasted: NullishType(Type.Enum(YesNo)), // Om fast, prognostiseras
    rows: Type.Array(SubForecastSchema),
});
export const ListForecastResponseSchema = Type.Array(ForecastSchema);
export const UpdateForecastsParamsSchema = Type.Object({
    id: Type.String(),
});
export const CreateForecastDetailParamsSchema = Type.Object({
    subForecastId: Type.String(),
});
export const CreateForecastDetailQuerySchema = Type.Object({
    createBefore: NullishType(Type.Boolean()),
});
export const UpdateForecastBodySchema = Type.Object({
    accountTranslation: NullishType(Type.String()),
});
export const UpdateForecastCommentBodySchema = Type.Object({
    comment: NullishType(Type.String()),
});
export const UpdateSubForecastBodySchema = Type.Object({
    comment: NullishType(Type.String()),
});
export const UpdateForecastDetailBodySchema = Type.Object({
    budget: NullishType(Type.Number()),
    forecast: NullishType(Type.Number()),
    result: NullishType(Type.Number()),
});
export const UpdateForecastDetailCommentBodySchema = Type.Object({
    comment: NullishType(Type.String()),
});
